import { useCallback, useMemo } from 'react';

import { DataStorageQuery, Query } from 'dashboard-services';

import { settingsSeriesActions } from 'actions/series';

import { useQueries } from '@tanstack/react-query';

export default(() => {

  const useKeysForGroups = ({ input, selectedSymbols, getApiConfig, getMetadataFilter = undefined, getSymbolFilter = undefined, getSelect }) => {
    const getQueryBuilder = useCallback(() => new Query.Builder(getApiConfig())
            .withFetching(false)
          , [getApiConfig]),
          queries = useMemo(() => selectedSymbols.map(s => {
            const filterSymbolObj = getSymbolFilter ? getSymbolFilter(s) : {}
            const filterMetadataObj = getMetadataFilter ? getMetadataFilter(s) : {}
            return { 
              ...DataStorageQuery.QUERIES.getSymbolKeys(
                getQueryBuilder,
                { 
                  groupName: s.groupName || "",
                  query: input ? `*${input}*` :  "*",
                  symbols: filterSymbolObj,
                  size: 100,
                  metadata: true,
                  metadatas: filterMetadataObj,
                  useEs: true,
                  omitRequiredKeys: true
                },
              ),
              select: getSelect
            }
          }), [getMetadataFilter, getSymbolFilter, getQueryBuilder, getSelect, input, selectedSymbols]),
          combine = useCallback(results => ({
            data: settingsSeriesActions.prepareKeysResponse(results.map(result => result.data)),
            isPending: results.some(result => result.isPending),
            isFetching: results.some(result => result.isFetching),
          }), [])
  
    return useQueries({
      queries,
      combine,
    })
  }

  return {
    useKeysForGroups
  }
})()

